module.exports = __webpack_public_path__ + "img/hcdl_gallery3.8b1e3f44.jpg";